module.exports = __webpack_public_path__ + "media/categories/3015-33098b77.svg";